export default __webpack_public_path__ + "static/media/Talia Ponesse.0274b178.png";